const publicS3bucket = 'https://renderro-public.s3.eu-central-1.amazonaws.com'

export const renderroWindowsClientUrlNew = `${publicS3bucket}/RenderroClient_22_07T.exe`
export const renderroMacOsClientUrlNew = `${publicS3bucket}/RenderroClient_22_04T.pkg`

export const uppyCompanionUrl = 'https://files-companion.backendonly.com'

export const archiveExtensions = ['.zip', '.rar', '.7z', '.tar', '.gz']
export const s3BulkOperationChunkSize = 1000
export const S3_PRESIGNED_LINK_LIFESPAN_HOURS = 1
export const stripeTestApiKey = 'pk_test_lGbuT8KfbxDuej7bFh02SrT400rde780XK'
export const stripeLiveApiKey = 'pk_live_jGV7qGhGMcBQmDPkvoai1IZk00pZZonlcH'

export const enableEmulators = false

function isProd(): boolean {
  // When running emulators process.env.NODE_ENV is set to 'production'! (due to npm run build)
  return process.env.NODE_ENV === 'production'
}

// Switch between renderro-mvp / connector (false) and renderro-dev / connector-test-2 here (true)
export const RUNNING_ON_DEV_SERVER = true

export const debug = !isProd() || enableEmulators

export const CONNECTOR_RUNNING_LOCALLY = false // toggle this when there's a connector running locally

export const getConnectorRootURL = (): string => {
  const CONNECTOR_PROD_URL = RUNNING_ON_DEV_SERVER
    ? 'https://connector-test-2.backendonly.com'
    : 'https://connector.backendonly.com'
  // ensure production url when on production
  if (isProd()) {
    return CONNECTOR_PROD_URL
  } else {
    const CONNECTOR_PORT = 8000
    const CONNECTOR_LOCAL_URL = `http://localhost:${CONNECTOR_PORT}`
    return CONNECTOR_RUNNING_LOCALLY ? CONNECTOR_LOCAL_URL : CONNECTOR_PROD_URL
  }
}

export function getAppRootURL(): string {
  const LOCAL_APP = 'http://localhost:8080'
  const PROD_APP = RUNNING_ON_DEV_SERVER
    ? 'https://renderro-dev.web.app'
    : 'https://app.renderro.com'
  return isProd() ? PROD_APP : LOCAL_APP
}

export const connectorApiUrl = getConnectorRootURL()
